export type PhotoAspect = 'screen' | '1:1' | '4:3' | '16:9' | '9:16';

export const PHOTO_ASPECTS: PhotoAspect[] = ['screen', '16:9', '4:3', '1:1', '9:16'];

export function photoAspectLabel(aspect: PhotoAspect): string {
  if (aspect === 'screen') return 'Full';
  return aspect;
}

export function photoAspectRatio(aspect: PhotoAspect): number | null {
  if (aspect === 'screen') return null;
  const map: Record<Exclude<PhotoAspect, 'screen'>, number> = {
    '1:1': 1,
    '4:3': 4 / 3,
    '16:9': 16 / 9,
    '9:16': 9 / 16,
  };
  return map[aspect as Exclude<PhotoAspect, 'screen'>];
}

export interface PhotoFrameRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

/** Frame rect in canvas client pixels (origin top-left). */
export function computePhotoFrame(cw: number, ch: number, aspect: PhotoAspect): PhotoFrameRect {
  if (cw <= 0 || ch <= 0) return { x: 0, y: 0, w: 0, h: 0 };
  const target = photoAspectRatio(aspect);
  if (target === null) return { x: 0, y: 0, w: cw, h: ch };

  const screenRatio = cw / ch;
  if (screenRatio > target) {
    const h = ch;
    const w = h * target;
    return { x: (cw - w) * 0.5, y: 0, w, h };
  }
  const w = cw;
  const h = w / target;
  return { x: 0, y: (ch - h) * 0.5, w, h };
}
